import { strCode } from "../../consts";
import { log, notificationService, s3ImageService, t } from "../../services";
import { fileUtils } from "../../utils";

export const useUploadReleaseNotesIcons = () => {
  const mutationCallback = async (mediaUrls = [], mediaData = []) => {
    try {
      const mediaPromises = [];

      mediaUrls?.forEach(async (config) => {
        const { id, media: mediaUrl } = config ?? {};
        let binaryMedia;

        const media = mediaData?.find(
          (item) => item?.id === id
        )?.media;

        if (media) {
          binaryMedia = await fileUtils.readFile(media);

          if (mediaUrl && binaryMedia) {
            mediaPromises.push(s3ImageService.uploadImage(mediaUrl, binaryMedia));
          }
        }
      });

      await Promise.all(mediaPromises);
    } catch (err) {
      log.error("useUploadReleaseNotesIcons: Failed to upload release note media", err);
      notificationService.showError({
        title: t(strCode.RELEASE_NOTES_ICON_UPLOAD_ERROR),
        message: err?.response?.data?.message ? err.response.data.message : err?.toString()
      });
    }
  };

  return { mutationCallback };
};
